import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/app/utils/cn';

export type OptionsGroupOrientation = 'horizontal' | 'vertical';
export interface OptionsGroupProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * (Optional) The class name of the options group
   */
  className?: string;
  /**
   * The orientation of the options group
   */
  orientation?: OptionsGroupOrientation;
  /**
   * The name of the options group
   */
  name: string;
  /**
   * (Optional) The role of the options group
   */
  role?: 'radiogroup' | 'group';
  /**
   * The children of the options group
   */
  children: ReactNode;
}

export const OptionsGroup = ({
  className,
  name,
  orientation = 'horizontal',
  role = 'radiogroup',
  children,
  ...props
}: OptionsGroupProps) => {
  return (
    <div
      className={cn(
        'flex',
        {
          'flex-wrap gap-x-6': orientation === 'horizontal',
          'flex-col': orientation === 'vertical',
        },
        className
      )}
      role={role}
      aria-labelledby={`${name}-label`}
      {...(role === 'radiogroup' && {
        ['aria-orientation']: orientation,
      })}
      {...props}
    >
      {children}
    </div>
  );
};
